<template>
    <div class="login_container">
        <header class="login_header">
            <img src="../../assets/img/login/logo.png" alt="">
        </header>
        <main class="login_main">
            <van-form @submit="onSubmit" class="form">
                <van-field
                    v-model="loginForm.username"
                    name="username"
                    label="用户名"
                    placeholder="请输入用户名"
                    :rules="[{ required: true, message: '请填写用户名' }]"
                />
                <van-field
                    v-model="loginForm.password"
                    type="password"
                    name="password"
                    label="密码"
                    placeholder="请输入密码"
                    :rules="[{ required: true, message: '请填写密码' }]"
                />
                <div class="verifycodebox">
                    <van-field
                        v-model="loginForm.verifyCode"
                        name="verifyCode"
                        label="验证码"
                        placeholder="请输入验证码"
                        :rules="[{ required: true, message: '请填写验证码' }]"
                    />
                    <img @click="changeImg" style="cursor:pointer;" :src="codeUrl">
                </div>
                <div style="margin:0.5rem 0.16rem 0;">
                    <van-button block color="#3bd3c1" type="info" native-type="submit">登录</van-button>
                </div>
            </van-form>
        </main>
        <div class="loading" v-if="show">
            <van-loading size="30px" vertical color="#3BD3C1">登录中...</van-loading>
        </div>
    </div>
</template>

<script>
import request from "../../utils/request.js";
export default {
  data() {
    return {
      loginForm: {
        username: "", //用户名
        password: "", //密码
        verifyCode: "" //验证码
      },
      codeUrl: "",
      show: false
    };
  },
  mounted() {
    request({
      url: "/api/verification",
      method: "post"
    }).then(response => {
      this.codeUrl = response.url;
    });
  },
  methods: {
    changeImg() {
      request({
        url: "/api/verification",
        method: "post"
      }).then(response => {
        this.codeUrl = response.url;
      });
    },
    onSubmit(values) {
        if(values.username && values.password && values.verifyCode) {
            this.show = true
            this.$store.dispatch('user/login', values).then(() => {
                this.show = false
                //登录成功之后重定向
                this.$router.push({ path: this.redirect || '/' })
                let that = this
                setTimeout(function(){
                    that.$toast({
                        message: '登录成功',
                    });
                },100)
            }).catch(() => {
                this.show = false
            });
        }
    }
  }
};
</script>

<style scoped>
.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #f5f5f5;
  z-index: 99999;
}

.loading > .van-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login_container {
  height: 100vh;
  background-color: #ffffff;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

.login_header {
    height: 1.3rem;
    background: url(../../assets/img/login/top_daka@3x.png) no-repeat center;
    background-size: 100% 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login_header > img {
    width: 1rem;
    height: 0.47rem;
    line-height: 1.3rem;
    margin-bottom: 0.2rem;
}

.login_main {
    position: absolute;
    top: 1.1rem;
}

.verifycodebox {
    display: flex;
    margin-right: 0.16rem;
}

.verifycodebox > img {
    width: 25%;
}

.form {
    width: 100vw;
}
</style>